import * as React from 'react';

export const IconPaid = (props: React.HTMLAttributes<SVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    {/* tslint:disable-next-line:max-line-length */}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.1 6.9h1.3V.5h3.1c1.5 0 2.5.2 3.2.8.9.6 1.5 1.6 1.5 3 0 1.1-.4 2.1-1.1 2.8-.9.9-1.9 1.3-3.7 1.3H5v1.1h5.6v1.4H5V13H3.3v-2.1H2.1V9.4h1.3V8.3H2.1V6.9zm6.5-4.5c-.6-.3-1.2-.5-2.2-.5H5v5h1.1c1.4 0 2.1-.2 2.7-.7.5-.5.7-1.1.7-1.9 0-.8-.3-1.5-.9-1.9z"
    />
  </svg>
);
